import { Box, Link } from '@mui/material';
import ROUTE from '../../../utils/router'
import { Link as RouterLink, useLocation } from 'react-router-dom'

const BottomBar = ({isMobile}) => {
    const { pathname } = useLocation()
    const mainRoutes = ROUTE.find(route => route.componentName === 'PublicLayout')
    const childrenRouters = mainRoutes.children.filter(route => route.menu && route.secondary)
  

    return (
        <>
          {
            !isMobile && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                gap={2}
                position="sticky"
                top={0}
                zIndex={1100}
                py={1}
                backgroundColor="background.paper"
              >
                {childrenRouters.map(route => {
                    const to = route.index ? mainRoutes.path : `/${route.path}`

                    return (
                        <Link
                            key={`main_menu_${route.path}`}
                            component={RouterLink}
                            to={to}
                            color="text.primary"
                            underline="none"
                            sx={{ '&:hover': { color: 'primary.main' } }}
                        >
                            {route.title}
                        </Link>
                    )
                })}
              </Box>
            )
          }
        </>
    );
};

export default BottomBar;